import classNames from 'classnames';
import React from 'react'
import { useMemo } from 'react';
import { SidekickCategories } from '../../../../static/categories';

import { ReactComponent as CrossButton } from './../../crossButton.svg';

const Category = ({ key, label, isChosenCategory, category, onChange}) => {

    const style = useMemo(() => {
        return isChosenCategory
            ? {
                backgroundColor: SidekickCategories[category].color,
                color: '#fff',
            }
            : {
                backgroundColor: '#F4F4F4',
                color: '#020810',
            };
    }, [isChosenCategory, category.color]);

    const baseCategoryClass = useMemo(() => {
        return classNames({
            categoryButton: true,
        });
    }, [category.uid]);

    return (
        <button
            key={key}
            style={style}
            type="button"
            className={baseCategoryClass}
            onClick={() => {
                onChange(SidekickCategories[category].uid);
            }}
        >
            <span>{label}</span>
            {isChosenCategory && <CrossButton />}
        </button>
    )
}

export default Category